import { CodeIcon } from "@heroicons/react/solid";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Projects = () => {
    const navigate = useNavigate();
    // const [id, setId] = useParams()
    const [project, setProject] = useState([])
    useEffect(() => {
        fetch('projects.json')
            .then(res => res.json())
            .then(data => setProject(data))
    }, [])
    const handleDetails = (_id) => {
        navigate(`/projects/${_id}`)
    }
    return (
        <section id="projects" className="text-gray-400 bg-gray-900 body-font mx-auto">
            <div className="container px-5 py-10 mx-auto text-center lg:px-20">
                <div className="flex flex-col w-full mb-20">
                    <CodeIcon className="mx-auto inline-block w-10 mb-4" />
                    <h1 className="sm:text-4xl text-3xl font-medium title-font mb-4 text-white">
                        Apps I've Built
                    </h1>
                    <p className="lg:w-2/3 mx-auto leading-relaxed text-base">
                        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Explicabo
                        facilis repellat ab cupiditate alias vero aliquid obcaecati quisquam
                        fuga dolore.
                    </p>
                </div>
                <div className="grid grid-cols-1 lg:grid-cols-3 lg:gap-4 lg:mx-4 justify-center">
                    {project.map((project) => (
                        <div class="w-80 shadow-2xl mx-auto" data-aos="zoom-in">
                            <a
                                href={project.link}
                                key={project.image}
                                className="sm:w-1/2 w-100 p-4">
                                <div className="flex relative">
                                    <img
                                        alt="gallery"
                                        className="absolute inset-0 w-full h-full object-cover  object-center"
                                        src={project.img}
                                    />
                                    <div className="px-8 py-10 relative z-20 w-full border-4 border-gray-800 bg-gray-900 opacity-0 hover:opacity-100">
                                        <h2 className="tracking-widest text-sm title-font font-medium text-green-400 mb-1">
                                            {project.subtitle}
                                        </h2>
                                    </div>
                                </div>
                            </a>
                            <div class="card-body items-center text-center">
                                <h2 class="card-title">{project.subtitle}</h2>
                                <p className="truncate w-80 px-3">{project.description}</p>
                                <div class="card-actions">
                                    <button onClick={() => handleDetails(project.id)} class="btn btn-sm">More Details</button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className="text-center">
                <button className="btn btn-primary"><a className="" href='https://drive.google.com/file/d/1iKzoMX0Vjlmu8s3Vf7OSlgBQK1moVOsA/view?usp=sharing' download>Resume</a></button>

            </div>

        </section>
    );
}

export default Projects;